"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieTokenStore = exports.TokensStore = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var cookie_listener_1 = __importDefault(require("@streamelements/cookie-listener"));
/**
 * A storage for tokens with multi instance capabilities and cross tab support.
 * All tokens are stored in cookies in order to not implement a local storage listener
 * */
var TokensStore = /** @class */ (function () {
    function TokensStore(cookieOptions) {
        this.cookieOptions = cookieOptions;
        this.main = new CookieTokenStore('id_token', cookieOptions);
        this.legacy = new CookieTokenStore('se-token', cookieOptions);
        this.creator = new CookieTokenStore('id_token_creator', cookieOptions);
        this.manager = new CookieTokenStore('manager_token', cookieOptions);
        this.roleplay = new CookieTokenStore('id_token_creator_roleplay', cookieOptions);
    }
    return TokensStore;
}());
exports.TokensStore = TokensStore;
var TokenStore = /** @class */ (function () {
    function TokenStore() {
    }
    return TokenStore;
}());
var CookieTokenStore = /** @class */ (function () {
    function CookieTokenStore(cookieName, cookieOptions) {
        this.cookieName = cookieName;
        this.cookieOptions = __assign({}, cookieOptions);
    }
    /**
     * Returns current token value
     * */
    CookieTokenStore.prototype.get = function () {
        return js_cookie_1.default.get(this.cookieName);
    };
    /**
     * Sets a new token value
     * */
    CookieTokenStore.prototype.set = function (value, cookieOptions) {
        if (cookieOptions === void 0) { cookieOptions = {}; }
        js_cookie_1.default.set(this.cookieName, value, __assign(__assign({}, this.cookieOptions), cookieOptions));
    };
    /**
     * Clears current token
     * */
    CookieTokenStore.prototype.clear = function (cookieOptions) {
        if (cookieOptions === void 0) { cookieOptions = {}; }
        js_cookie_1.default.remove(this.cookieName, __assign(__assign({}, this.cookieOptions), cookieOptions));
    };
    /**
     * Listens for token changes. Even if done in different tabs or manually
     * */
    CookieTokenStore.prototype.onChange = function (handler) {
        var _this = this;
        return cookie_listener_1.default.onChange(this.cookieName, function (cookies) {
            handler(cookies[_this.cookieName]);
        });
    };
    return CookieTokenStore;
}());
exports.CookieTokenStore = CookieTokenStore;
